import FuseUtils from "@fuse/utils";
import FuseLoading from "@fuse/core/FuseLoading";
import { Navigate } from "react-router-dom";
import settingsConfig from "app/configs/settingsConfig";
import { FuseRouteConfigsType, FuseRoutesType } from "@fuse/utils/FuseUtils";
import SignInConfig from "../main/sign-in/SignInConfig";
import SignUpConfig from "../main/sign-up/SignUpConfig";
// import SignOutConfig from '../main/sign-out/SignOutConfig';
import Error404Page from "../main/404/Error404Page";
// import ExampleConfig from '../main/example/ExampleConfig';
//import page configs
import HomeConfig from "../main/home/HomeConfig";

import CleanConfig from "../main/clean/CleanConfig";
import CleaningSessionsConfig from "../main/cleaning-sessions/CleaningSessionsConfig";
import RoomieAIConfig from "../main/roomie-ai/RoomieAIConfig";
import ProblemsConfig from "../main/problems/ProblemsConfig";

import SettingsAppConfig from "../main/settings/SettingsAppConfig";
import HelpCenterAppConfig from "../main/help-center/HelpCenterAppConfig";
import NotificationsAdminConfig from "../main/admin/notifications/NotificationsAdminConfig";
import OfflinePageConfig from "../main/offline/OfflinePageConfig";

const routeConfigs: FuseRouteConfigsType = [
  HomeConfig,
  CleanConfig,
  CleaningSessionsConfig,
  RoomieAIConfig,
  ProblemsConfig,
  SettingsAppConfig,
  HelpCenterAppConfig,
  NotificationsAdminConfig,
  SignInConfig,
  SignUpConfig,
  OfflinePageConfig,
];

/**
 * The routes of the application.
 */
const routes: FuseRoutesType = [
  ...FuseUtils.generateRoutesFromConfigs(
    routeConfigs,
    settingsConfig.defaultAuth
  ),
  {
    path: "/",
    element: <Navigate to="/home" />,
    auth: ["Godfather", "Admin", "Reception", "Main Cleaner"],
  },
  {
    path: "/clean",
    element: <Navigate to="/clean" />,
    auth: ["Godfather", "Admin", "Cleaner", "Main Cleaner"],
  },
  {
    path: "/cleaning-sessions",
    element: <Navigate to="/cleaning-sessions" />,
    auth: ["Godfather", "Admin", "Reception", "Main Cleaner"],
  },
  {
    path: "/roomie-ai",
    element: <Navigate to="/roomie-ai" />,
    auth: ["Godfather", "Admin", "Reception", "Main Cleaner"],
  },
  {
    path: "/maintenance",
    element: <Navigate to="/maintenance" />,
    auth: ["Godfather", "Admin", "Reception", "Main Cleaner", "Tech Support"],
  },
  {
    path: "/settings",
    element: <Navigate to="/settings" />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: "loading",
    element: <FuseLoading />,
  },
  {
    path: "404",
    element: <Error404Page />,
  },
  {
    path: "*",
    element: <Navigate to="404" />,
  },
];

export default routes;
